import CoreAPI from '../Core/CoreAPI';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';

class NpsAPI {
  constructor() {
    this.setApi(new CoreAPI(getSessionItem('API_MS_CUSTOMER_SURVEYS')));
  }

  setApi(api) {
    this.api = api;
  }

  getAPI() {
    if (!this.api.baseURL) this.setApi(new CoreAPI(getSessionItem('API_MS_CUSTOMER_SURVEYS')));

    return this.api;
  }

  async getActions() {
    const result = await this.getAPI().getInstance().get(`v1/Actions`);
    return result;
  }

  async getAction(email, name, actionId) {
    const result = await this.getAPI().getInstance().get(`v1/Actions/${actionId}`, {
      params: { email, name }
    });
    return result;
  }

  async postAnswersAction(formData) {
    const result = await this.getAPI()
      .getInstance()
      .post(`v1/actions/${formData.actionId}/answers`, formData);
    return result;
  }
}

const api = new NpsAPI();
export default api;
